/**
 * Seeded once from grantable-paths.json on 2026-10-08; edit by hand from here.
 *
 * Admin\Report Views: report view publishing and dashboard authoring. Moved under `Admin` from the
 * root on 2026-10-12 (chore/security-path-reorg).
 */

import { admin } from './admin';

export const reportViews = admin.tool('Report Views');
export const authorDashboard = reportViews.command('Author Dashboard');
export const publish = reportViews.command('Publish');
export const publishAuthored = reportViews.command('PublishAuthored');
export const publishCore = reportViews.command('PublishCore');
